import FpTabs from './FpTabs.jsx'
export default FpTabs
